import { useRef, useState } from 'react'
import classNames from 'classnames'

import RupayInfraLayout from './RupayInfraLayout'
import CardsWithMediaPlayer from '../CardsWithMediaPlayer/CardsWithMediaPlayer'
import Headline from '../Headline/Headline'
import MissionCard from '../MissionCard/MissionCard'
import { getImageUrl, scrollElemToTop } from '../../utils'
import styles from './RupayLayout.module.scss'
import { INFRASTRUCTURE, INTEROPERABILITY } from '../../Contansts'

function RupayLayout({ cards, page, buttonText, hideVideo }) {
  const infoRef = useRef(null)
  const [selectedCard, setSelectedCard] = useState(cards[0] || [])
  function cardClickHandler(card) {
    setSelectedCard(card)
  }

  const handleReadMoreClick = () => {
    if (infoRef.current) {
      scrollElemToTop(infoRef.current.offsetTop)
    }
  }

  return (
    <div className={styles.container}>
      <CardsWithMediaPlayer
        selectedCard={selectedCard}
        cards={cards}
        cardClickHandler={cardClickHandler}
        handleReadMoreClick={handleReadMoreClick}
        className={page === INFRASTRUCTURE && 'page-container'}
        buttonText={buttonText}
        hideVideo={hideVideo}
      />
      <div ref={infoRef} className={styles.infoContainer}>
        {selectedCard?.headlinetitle && (
          <Headline
            title={selectedCard?.headlinetitle}
            paragraphs={selectedCard?.headlinedecription}
            introduction={selectedCard?.introduction}
            className={page === INFRASTRUCTURE && 'page-container'}
          />
        )}
        {page === INTEROPERABILITY && (
          <>
            <div className={styles.missionCardContainer}>
              <h1>{selectedCard?.missionheader}</h1>
              <div
                className={classNames(
                  'grid grid-cols-1 md:grid-cols-3 gap-y-3 gap-x-10'
                )}
              >
                {selectedCard.missioncards?.map((card) => {
                  return (
                    <MissionCard
                      key={card?.id}
                      imageUrl={getImageUrl(card?.image)}
                      title={card?.title}
                      description={card?.description}
                      linkTitle={card?.link?.label}
                      linkPath={card?.link?.path}
                      alternativeText={card?.image?.alternativeText}
                    />
                  )
                })}
              </div>
            </div>
            <Headline
              title={selectedCard?.headlinetitleadditional}
              paragraphs={selectedCard?.headline_desc_additional}
              introduction={selectedCard?.infra_introduction}
              className={page === INFRASTRUCTURE && 'page-container'}
            />
          </>
        )}
        {page === INFRASTRUCTURE && (
          <RupayInfraLayout selectedCard={selectedCard} />
        )}
      </div>
    </div>
  )
}

export default RupayLayout
